import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import {Integrations} from '@sentry/tracing';
import Config from '../config';

/**
 * @return {*}
 */
function initSentry() {
    if (!Config.SENTRY_DSN) return;
    Sentry.init({
        Vue,
        tracingOptions:   {
            trackComponents: true,
        },
        release:          Config.VERSION,
        attachProps:      true,
        integrations:     [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
        dsn:              Config.SENTRY_DSN,
    });
}

initSentry();
